import { render, staticRenderFns } from "./AlterarUnidade.vue?vue&type=template&id=5f8dcb1a&"
import script from "./AlterarUnidade.vue?vue&type=script&lang=js&"
export * from "./AlterarUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports